export const DROPDOWN_EDGE_MARGIN_PX = 8;
/** Ceiling a content-sized panel may grow to before its labels start to
 *  ellipsize. Chosen from the row budget: the chrome and the fixed slots eat
 *  168px (12px surface pad + 16px container pad + 20px row pad per side, plus
 *  the 28px icon frame, its 14px gap, the 16px label-to-chevron gap and the
 *  14px chevron), so 360px leaves a 192px label runway — about 24 characters at
 *  the 15px option size. Call sites rendering dynamic text override it. */
export const DEFAULT_DROPDOWN_MAX_WIDTH_PX = 360;
/** Both fixed slots in an option row. They are `flexShrink: 0`, so these are
 *  the widths the row budget above actually reserves. */
export const OPTION_ICON_FRAME_SIZE_PX = 28;
export const OPTION_HOVER_INDICATOR_SIZE_PX = 14;
export const CARET_DROPDOWN_HEIGHT_PADDING_PX = 24;
export const FALLBACK_WIDTH_PX = 216;
export const ACTIVE_ITEM_SCROLL_VISIBILITY_PADDING_PX = 18;
export const ESTIMATED_DROPDOWN_ITEM_HEIGHT_PX = 40;
export const DROPDOWN_OPTION_ANIMATION_DELAY_MS = 35;

export const CDROPDOWN_MODE = {
  Trigger: "trigger",
  Caret: "caret",
} as const;

export const CDROPDOWN_ALIGN = {
  Left: "left",
  Right: "right",
  Center: "center",
} as const;

export const CDROPDOWN_OPEN_DIRECTION = {
  Auto: "auto",
  Up: "up",
  Down: "down",
} as const;

export const DROPDOWN_KEY = {
  Escape: "Escape",
  ArrowDown: "ArrowDown",
  ArrowUp: "ArrowUp",
  Enter: "Enter",
} as const;

export const DROPDOWN_SCROLL_DIRECTION = {
  Vertical: "vertical",
} as const;

export const DROPDOWN_TRANSFORM_ORIGIN = {
  Left: "left",
  BottomCenter: "bottom center",
  TopCenter: "top center",
  BottomRight: "bottom right",
  TopRight: "top right",
  BottomLeft: "bottom left",
  TopLeft: "top left",
} as const;

export const DROPDOWN_TRANSFORM = {
  Open: "translateY(0) scale(1) rotateX(0)",
  ClosedUpwards: "translateY(15px) scale(0.95) rotateX(-10deg)",
  ClosedDownwards: "translateY(-15px) scale(0.95) rotateX(10deg)",
  ItemHovered: "translateX(6px)",
  ItemIdle: "translateX(0)",
  ItemClosed: "translateX(-15px) rotateY(-10deg)",
} as const;

export const DROPDOWN_TEXT_SHADOW = {
  Highlighted: "0 0 12px rgba(255,255,255,0.4)",
  None: "none",
} as const;
